module.exports = __webpack_public_path__ + "img/verify.f5822097.png";